"use strict";

var __importDefault = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Plugins Vue.js
 */
var vue_1 = __importDefault(require("vue"));
var moment_addon_1 = __importDefault(require("./moment-addon"));
/**
 * Directive qui permet de donner le focus à l'affichage du champ
 */
vue_1.default.directive("focus", {
    // When the bound element is inserted into the DOM...
    inserted: function inserted(el) {
        // Focus the element
        el.focus();
    }
});
/**
 * Filtre qui permet d'affiche une taille de fichier de façon lisible
 */
vue_1.default.filter("file-size", function (bytes) {
    var sizes = ["Octets", "Ko", "Mo", "Go", "To"];
    if (bytes <= 0) {
        return "n/a";
    }
    var i = Math.floor(Math.log(bytes) / Math.log(1024));
    if (i === 0) {
        return bytes + " " + sizes[i];
    }
    return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
});
/**
 * Filtre de formatage de date
 */
vue_1.default.filter("date-format", function (value, format) {
    if (format === void 0) {
        format = "DD/MM/YYYY";
    }
    if (value) {
        return moment_addon_1.default(String(value)).format(format);
    }
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Addons/vue-plugins.ts
// module id = 515
// module chunks = 0